import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import ReactApexChart from 'react-apexcharts';

import { rawGraphData } from '../APIcalls/data';

export const AreaGraph = ({ token }) => {
  const [graphData, setGraphData] = useState();
  const [count, setCount] = useState(0);

  useEffect(() => {
    const getGraphData = async () => {
      const res = await fetch(
        `https://faucet.reliantnode.com/daily-swaps/${token}`
      );
      setCount(count + 1);
      const data = await res.json();
      // rawGraphData.options.labels = data.labels;
      // rawGraphData.datasets[0].data = data.datasets[0].data;
      // rawGraphData.datasets[1].data = data.datasets[1].data;
      setGraphData(rawGraphData);
    };
    getGraphData();
  }, [token]);

  if (!graphData) return <div></div>;

  return (
    <ChartWrapper id="chart">
      <ReactApexChart
        options={graphData.options}
        series={graphData.datasets}
        type="line"
        height={350}
      />
    </ChartWrapper>
  );
};

export default AreaGraph;

const ChartWrapper = styled.div`
  @media (max-width: 414px) {
    transform: rotate(90deg);
    width: 1100px;
    height: 600px;
    margin-top: 440px;
    padding-left: 300px;
  }
`;
